<template>
    <div>
        <CompassTooltip
            :content="tooltip"
            :delay="{ show: 0, hide: 1 }"
            :disabled="disabled"
            placement="top"
        >
            <CompassIconButton
                ref="colorPaletteTrigger"
                :icon="icon"
                :disabled="disabled"
                :active="active"
                size="small"
                @click="$emit('update:visibility', !isVisible)"
            />
        </CompassTooltip>
        <CompassPopover
            :isVisible="isVisible"
            customClass="color-palette-popover"
            triggerRef="colorPaletteTrigger"
            @close="$emit('update:visibility', false)"
        >
            <template>
                <div class="color-palette__content">
                    <div class="color-palette__colors">
                        <div
                            v-for="(row, rowIndex) in colorsGrid"
                            :key="rowIndex"
                            class="color-palette__colors-row"
                        >
                            <div
                                v-for="(color, colIndex) in row"
                                :key="colIndex"
                                class="color-palette__colors-cell"
                            >
                                <label
                                    :for="`color_${rowIndex}_${colIndex}`"
                                    class="color-palette__colors-label"
                                    :style="{ backgroundColor: color }"
                                    @click="$emit('update:value', color)"
                                >
                                    <CompassIcon
                                        v-if="value === color"
                                        icon="check"
                                        size="small"
                                        class="color-palette__colors-icon"
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="color-palette__form">
                        <CompassColorInput
                            :value="value"
                            :canSelectColor="false"
                            size="small"
                            class="color-palette__form-color-input"
                            @change="(color) => $emit('update:value', color)"
                        />
                        <CompassIconButton
                            class="color-palette__form-reset-button"
                            icon="paint-off"
                            size="small"
                            @click="$emit('reset:value')"
                        />
                    </div>
                </div>
            </template>
        </CompassPopover>
    </div>
</template>

<script>
export default {
    props: {
        tooltip: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: 'richeditor-text-color',
        },
        colorsGrid: {
            type: Array,
            default: () => [],
        },
        value: {
            type: String,
            default: '',
        },
        active: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.color-palette {
    &__colors {
        position: relative;
        padding-bottom: var(--spacing-1);
        margin-bottom: var(--spacing-1);

        &::after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 1px;
            background-color: var(--colors-common-border-lighter);
        }

        &-row {
            display: flex;
        }

        &-cell {
            padding: 2px;
        }

        &-label {
            width: 20px;
            height: 20px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            border-radius: 50%;
            border: 1px solid var(--colors-common-border-on-color);

            &:hover {
                border: 1px solid var(--colors-common-border-lighter);
                box-shadow: 0 0 0 1px var(--colors-common-border-mask),
                    0 0 0 2px var(--colors-common-border-on-color);
            }
        }

        &-icon {
            color: var(--colors-common-text-standard-on-color);
        }
    }

    &__form {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--spacing-1);

        &-color-input {
            max-width: 110px;
        }

        &-reset-button {
            flex-shrink: 0;
        }
    }
}
</style>

<style lang="scss">
.color-palette__form-color-input .compass-input {
    width: 100%;
}
</style>
